/**
 * Page Bootstrap
 * Common initialization for all MPA pages
 */

import sessionBootstrap from '../services/sessionBootstrap.js';

const processEnv = typeof process !== 'undefined' && process.env ? process.env : {};

const disableConsoleLogs =
  processEnv.DISABLE_CONSOLE_LOGS === 'true' ||
  processEnv.VUE_APP_DISABLE_CONSOLE_LOGS === 'true';

if (disableConsoleLogs) {
  console.log = () => {};
}

/**
 * Initialize common services for all pages
 */
export async function initializePage() {
  try {
    // Initialize session token management
    await sessionBootstrap.initialize();
    
    return {
      success: true,
      sessionToken: sessionBootstrap.getCurrentToken()
    };
  } catch (error) {
    console.error('[PageBootstrap] Initialization failed:', error);
    
    return {
      success: false,
      error: error.message
    };
  }
}

/**
 * Get current session token for API calls
 */
export function getSessionToken() {
  return sessionBootstrap.getCurrentToken();
}

/**
 * Clear session (for logout)
 */
export function clearSession() {
  sessionBootstrap.clearSession();
}

export default {
  initializePage,
  getSessionToken,
  clearSession
};
